import {Component, ViewChild} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { ModalComponent } from 'angular-custom-modal';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ccloud-angular-app';
  mainTitle: string;
  titleShow = true;
  showSources = false;
  showTopBar = true;

  @ViewChild('aboutModal') aboutModal: ModalComponent;

  openFromComponent() {
    this.aboutModal.open();
  }

  modalCloseAbout() {
    this.aboutModal.close();
  }

  constructor(private router: Router) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.titleShow = true;
        this.showSources = false;
        this.showTopBar = true;

        console.log(event);

        switch (event.url) {
          case '/home':
            this.mainTitle = 'Home';
            break;
          case '':
            this.mainTitle = 'Home';
            break;
          case '/themes':
            this.mainTitle = 'Themes';
            break;
          case '/sources':
            this.mainTitle = 'Sources';
            this.showSources = true;
            break;
          case '/account':
            this.mainTitle = 'Account';
            break;
          case '/search':
            this.mainTitle = 'Search';
            this.titleShow = false;
            this.showTopBar = false;
            break;
          case '/installed':
            this.mainTitle = 'Installed Applications';
            this.titleShow = false;
            break;
          default:
            this.mainTitle = '';

            const stringSplitUrl = event.url.split('/');
            const lastPara = stringSplitUrl[stringSplitUrl.length - 1];

            if (!isNaN(Number(lastPara))) {
              const beforeLastPara = stringSplitUrl[stringSplitUrl.length - 2];
              const beforeLastPara2 = stringSplitUrl[stringSplitUrl.length - 3];
              console.log(beforeLastPara);
              if (beforeLastPara === 'singleapp') {
                this.showTopBar = false;
                console.log(this.showTopBar);
              } else if (beforeLastPara === 'changes' || beforeLastPara2 === 'changes') {
                this.showTopBar = false;
              } else if (beforeLastPara === 'author' || beforeLastPara2 === 'author') {
                this.showTopBar = false;
              }

            }

            break;
        }
      }
    });
}
}
